<div class="avatar-initials" [ngClass]="classes()">{{initials}}</div>